import React from 'react';
import { DraftViewer } from './DraftViewer';

export function TableContent({ aligns, rows }) {
	if (!Array.isArray(rows)) {
		return null;
	}

	const [headerRow, ...recordRows] = rows;
	aligns = aligns || [];

	const getAlignStyle = j => ({
		textAlign: aligns[j] && aligns[j].align || null
	});

	return (
		<div className="table-wrapper">
			<table>
				<thead>
					<tr>
						{headerRow.cells.map((cell, j) => (cell ? cell.raw ?
							<th key={cell.key} style={getAlignStyle(j)} colSpan={cell.colspan} rowSpan={cell.rowspan}>
								<DraftViewer raw={cell.raw} nested className="table-header" />
							</th> : null :
							<th key={'empty-cell' + j}></th>
						))}
					</tr>
				</thead>
				<tbody>
					{recordRows.map((row, i) => (row ?
						<tr key={row.key}>
							{row.cells.map((cell, j) => (cell ? cell.raw ?
								<td key={cell.key} style={getAlignStyle(j)} colSpan={cell.colspan} rowSpan={cell.rowspan}>
									<DraftViewer raw={cell.raw} nested className="table-cell" />
								</td> : null :
								<td key={'empty-cell' + j}></td>
							))}
						</tr> :
						<tr key={'empty-row' + i}></tr>
					))}
				</tbody>
			</table>
		</div>
	);
}



// WEBPACK FOOTER //
// ./lib/viewer/TableContent.jsx